import { Threshold } from '@modules/iot/model';
import { z } from 'zod';
import { Measure } from '@modules/measures/model';
import { SensoterraSchema } from '@modules/sensors/sensoterra/schema';

export namespace Sensoterra {
  export const Id = z.number().brand('SensoterraId');
  export type Id = z.infer<typeof Id>;

  export namespace Parameter {
    export const Id = z.coerce.number().brand('SensoterraParameterId');
    export type Id = z.infer<typeof Id>;

    export const Key = z.string().min(1).brand('SensoterraParameterKey');
    export type Key = z.infer<typeof Key>;

    export enum Type {
      Soil = 'SOIL',
      Depth = 'DEPTH',
    }
  }

  export interface Parameter {
    id: Parameter.Id;
    type: Parameter.Type;
    key: Parameter.Key;
    name: string;
  }

  export namespace Config {
    export interface Remote {
      id: Sensoterra.Id;
      soilType: Parameter.Key;
      depth: Parameter.Key;
    }
  }
  export interface Config {
    id: Sensoterra.Id;
    soilType: Parameter.Key;
    depth: Parameter.Key;
    humidityThreshold: Threshold.HumidityScale;
  }

  export namespace Probe {
    export enum Identifier {
      Ground = 'ground',
    }

    export const identifierProbeAlerts: Record<Identifier, Array<Measure.Type>> = {
      [Identifier.Ground]: [Measure.Type.Humidity, Measure.Type.Battery],
    };
  }

  export type RegisterParams = z.infer<typeof SensoterraSchema.registerSensoterraSchema>;
}
